import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Clint.css';

const Clint = () => {
    return (
        <div className="container-fluid mt-0 px-0">
            <div className="clint-block shadow">
                <h6 className="clint-header text-center py-3 text-white fw-bold">
                    We are Expanding our Cliental Base
                </h6>
                <div className="clint-body text-white">
                    <div className="scrolling-text-wrapper">
                        <div className="scrolling-text">
                            <span>Japan</span>
                            <span>Bangladesh</span>
                            <span>Nepal</span>
                            <span>UAE</span>
                            <span>Saudi Arabia</span>
                            <span>Africa</span>
                            <span>USA</span>
                            <span>Germany</span>
                            <span>Canada</span>
                            <span>China</span>
                            <span>Russia</span>
                            <span>Singapore</span>
                            <span>Nigeria</span>
                            <span>🌍 .....................</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Clint;
